module.exports = __webpack_public_path__ + "img/06.8fb82010.png";